export default "__VITE_ASSET__Dmm$NMeD__"